<input
  type="text"
  inputmode="numeric"
  class="border-default bg-surface text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus block w-full rounded-lg border p-2.5 text-sm"
  [value]="value() ?? ''"
  [id]="id()"
  [placeholder]="placeholder() ?? ''"
  [required]="required()"
  [min]="min()"
  [max]="max()"
  [step]="step()"
  pattern="[0-9]*"
  (blur)="onTouched()"
  (input)="onInput($event)" />
